export class AtributoCGR {
    nombre: string;
    valor: string;

}

